define('lib/validator/ValidatorNotEmpty',['require','lib/validator/ValidatorAbstract'],function (require) {

	var ValidatorAbstract = require('lib/validator/ValidatorAbstract');
	
	return ValidatorAbstract.extend({
        
        options: {
            error: 'error_value_is_empty'
        },
		
		/**
		 * Validates value
		 *  
		 * @param mixed value
		 */
		validate: function (value) {
			if (_.isString(value)) {
				value = String(value).trim();
			}
			if (!value) {
				this.addError(this.options.error);
			}
		}
	
	});
	
});
